import {h, Fragment} from "preact"
const EVERGREEN_COUPONS = {
  "CRATEJOY10": "10% off 1st box",
  "CJSAVE10": "10% off",
  "CJSAVE15": "15% off",
  "CJSAVE20": "20% off",
  "CJSAVE25": "25% off",
  "CJSAVE30": "30% off",
  "WELCOME20": "20% off 1st box",
  "CRATEJOY20": "20% off 1st box",
  "CRATEJOY25": "25% off 1st box",
  "CRATEJOY30": "30% off 1st box",
  "HALFOFF": "50% off 1st box",
  "FIRSTBOXFREE": "1st box free",
  "FREESHIPFORYOU": "Free shipping",
  "VERINT30": "30% off 1st box",
};
const SUBSCRIPTION = "Subscription"

export default ({ code, tag, type, collectionDiscountTag }) => {
  // TODO: Unfortunatly, we don't have the `product.collections` context
  // So we cannot tell what active deals should be promoted in Nosto

  const productDiscount = EVERGREEN_COUPONS[code] || tag || code;
  const discount = collectionDiscountTag || productDiscount; // Gives priority to collection first

  if (!discount) return;

  const shouldShowNewSearch = window.cj.nosto.newSearchFeatureEnabled
  const discountTags = code && EVERGREEN_COUPONS[code];
  const firstBox = discountTags && discountTags.includes("1st box");
  const colorClass = firstBox ? "discount-flag--purple" : "discount-flag--green";

  const DiscountBanner = () => {
    return (
      <div class="banner-div z-10">
        <div class="discount-banner-new">{discount}</div>
        {type?.value && type.value !== SUBSCRIPTION && (
          <div class="discount-type">
            {type.value}
          </div>
        )}
      </div>
    )
  }

  if (shouldShowNewSearch) return (<DiscountBanner />);

  return (
    <div class="discount-flag-wrapper">
      {cookieValue?.discountCode && cookieValue?.discountTags && cookieValue?.collectionId && cookieValue?.discountId ? (
        <div class="discount-flag discount-flag--purple">
          <div class="discount-flag--content mr-2.5">
            <div>{cookieValue.discountTags}</div>
          </div>
        </div>
      ) : (
        <div class={`discount-flag ${colorClass}`}>
          <div class="discount-flag--content">
            {firstBox && (
              <div>
                1<sup>st</sup> box
              </div>
            )}
            <div>{EVERGREEN_COUPONS[code].replace("1st box", "").trim()}</div>
          </div>
        </div>
      )}
    </div>
  );
};
